import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { IColor } from "./types";
import ColorCell from "./ColorCell";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface IColorRecord extends Pick<IColor, '_id' | 'title' | 'hex' | 'isActive'> {
    actions: unknown;
}

const ColorList = () => {

    const { records, handleInteraction, deleteRecord, paginationState } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<IColorRecord>[] =  [
        {
            Header: 'Нэр',
            accessor: 'title',
        },
        {
            Header: 'Өнгө',
            accessor: 'hex',
            Cell: ({ value }) => {
                return <ColorCell value={value}/>;
            },
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default ColorList;